import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { LOADING, setUserSession } from "../redux/global/actions";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { MaterialSymbol } from "@datalake/towercontrol-banner";
import { getLogo } from "../widgets/utils";

export default function Login(props) {
  const userSession = useSelector((state) => state.userSession);
  const dispatch = useDispatch();

  useEffect(() => {
    async function getSession() {
      try {
        dispatch({ type: LOADING, loading: true });
        var session = await Auth.currentSession();
        dispatch(setUserSession({ session }));
      } catch (err) {
        console.log(err);
        handleLogin();
      }
    }
    getSession();
  }, []);
  async function handleLogin() {
    try {
      Auth.federatedSignIn({ customProvider: "Alcatel-Login" });
    } catch (e) {
      alert(e);
    }
  }
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 400 }}>
        <CardContent
          sx={{
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{ mb: 3 }}
          >
            <Box
              role="img"
              aria-label="Alcatel-Lucent Enterprise"
              sx={{
                width: 48,
                height: 48,
                backgroundImage: getLogo(),
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            />
            <Typography variant="h1" component="span">
              Victoria
            </Typography>
          </Stack>
          <Typography variant="h3" component="h1" sx={{ mb: 1 }}>
            Explore the datalake
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Sign in with your Alcatel-Lucent Enterprise account
          </Typography>
          <Button
            variant="contained"
            size="large"
            fullWidth
            startIcon={<MaterialSymbol name="login" size="button" />}
            onClick={handleLogin}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
